import AdrielInput from '@/components/Common/AdrielInput.vue';
import { ActionButton } from '@/components/Common/Dialog';
import {
    applyHoverAndPress,
    BLACK,
    GRAY,
    square,
} from '@/styles/common.styled';
import Vue from 'vue';
import styled from 'vue-styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;
`;

export const Desc = styled.p`
    width: 100%;
    color: #2a333d;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

export const NoteWrapper = styled.div`
    margin-top: 16px;
    width: 100%;
    min-height: 34px;
    background-color: #f4f6f8;
    padding: 4px 16px 4px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-left: 3px solid #8f95a0;
    border-radius: 2px;

    .info-icon {
        width: 15px;
        height: 15px;
        flex-shrink: 0;
        fill: #8f95a0;
    }
`;

export const NoteText = styled.div`
    color: #6e767d;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.065px;
`;

export const CTAWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 0 -28px;
    margin-top: auto;
    padding: 16px 28px;
    gap: 8px;
    border-top: 1px solid #d4d8db;
    flex-shrink: 0;
`;

export const CancelActionButton = styled(ActionButton)`
    color: ${BLACK(100)};
    background: unset;
    &:hover,
    &:active {
        background-color: #f7f7f7;
    }
`;

export const SearchInputWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 8px 13px;
    gap: 8px;
    border-radius: 2px;
    align-items: center;
    background: #f4f6f8;
`;

export const SearchInput = styled(Vue.component('adriel-input', AdrielInput))`
    background: transparent !important;
    display: flex !important;
    border: none !important;
    outline: none !important;
    width: 100% !important;
    height: 100% !important;
    font-size: 13px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 18px !important;
    padding: 0 !important;
    border-radius: 0 !important;

    ::placeholder {
        color: #bdc2c7 !important;
    }
`;

export const SearchIconWrapper = styled.span`
    width: 16px;
    height: 16px;
`;

export const BreakdownBtn = styled('button', { lang: String })`
    border-radius: 2px;
    border: 1px solid ${GRAY(30)};
    padding: 0 10px;
    color: ${GRAY(80)};
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${({ lang }) => (lang === 'ko' ? '120px' : '180px')};
    flex-shrink: 0;
    height: 34px;
    ${applyHoverAndPress('white', 'background-color')};
    & svg {
        ${square(15)};
        fill: ${GRAY(100)};
        margin-right: 4px;
    }
`;

export const SearchAndBreakdownWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

export const ListSpacer = styled.div`
    margin-top: 12px;
    flex: 1;
    min-height: 0;
    overflow: auto;
`;

export const CategoryContent = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;
    width: 100%;
`;

export const CategoryText = styled.span`
    min-width: 0;
    text-align: left;
`;

export const CategoryBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    margin-left: 6px;
    border-radius: 999px;
    background: #dfe3e5;
    color: #2a333d;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    flex-shrink: 0;
`;

export const NoResultWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 100px;
    color: #8f95a0;
    text-align: center;
`;
